import React from 'react'
import ReactDOM from 'react-dom'
import Main from './components/Main'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'

import store from './store'
import './utils/vh'

ReactDOM.render(
  <Provider store={store}>
    <Main />
  </Provider>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
